<script setup lang="ts">
    import type { Schemas } from '#shopware';

    const props = defineProps<{ product: Schemas['Product'] }>();

    const { product } = toRefs(props);

    const discountValue = ref();

    if (product.value.calculatedCheapestPrice && product.value.calculatedPrice?.unitPrice) {
        discountValue.value = Math.floor(
            100 - (product.value.calculatedCheapestPrice?.unitPrice / product.value.calculatedPrice?.unitPrice) * 100
        );
    }
</script>
<template>
    <div class="discount-badge">
        <p>{{ '-' + discountValue + '%' }}</p>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/product-card/discount-badge.scss';
</style>
